import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PdfPreviewService {
    public openPdfInNewWindow(fileStreamResult: any) {
        let blob = new Blob([fileStreamResult.data], {
            type: 'application/pdf',
        });
        let fileName = `${fileStreamResult.fileName}`;
        let fileURL = URL.createObjectURL(blob);

        const html = this.getHtmlContent(fileName, fileURL);
        const win = window.open('', '_blank');
        if (win) {
            win.document.write(html);
            win.document.close();

            const checkWindowClosed = setInterval(() => {
                if (win.closed) {
                    clearInterval(checkWindowClosed);
                    URL.revokeObjectURL(fileURL);
                }
            }, 3000);
        }
    }

    private getHtmlContent(fileName: string, fileURL: string): string {
        return `
            <html>
                <head>
                    <title>${fileName}</title>
                    <style>
                        html, body {
                            margin: 0;
                            padding: 0;
                            height: 100%;
                            overflow: hidden;
                            font-family: sans-serif;
                        }
                        #toolbar {
                            height: 50px;
                            background: #282828;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 16px;
                            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        }
                        #downloadBtn {
                            padding: 8px 16px;
                            background: #007bff;
                            color: white;
                            border: none;
                            border-radius: 4px;
                            cursor: pointer;
                            font-size: 14px;
                        }
                        #pdfFrame {
                            width: 100%;
                            height: calc(100% - 50px);
                            border: none;
                        }
                        #fileName {
                            color: #fff;
                            font-weight: bold;
                        }
                    </style>
                </head>
                <body>
                    <div id="toolbar">
                        <div id="fileName">${fileName}</div>
                        <button id="downloadBtn">Download</button>
                    </div>
                    <iframe id="pdfFrame" src="${fileURL}#toolbar=0" allowfullscreen></iframe>
                    <script>
                        document.getElementById('downloadBtn').addEventListener('click', function () {
                            const link = document.createElement('a');
                            link.href = '${fileURL}';
                            link.download = '${fileName}';
                            link.click();
                        });
                    </script>
                </body>
            </html>
        `;
    }
}
